import { useState } from 'react';
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useTranslation } from 'react-i18next';
import { maintenanceService } from 'services/api';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import toast from 'features/toast';
import 'dayjs/locale/it';
dayjs.locale('it');
import dayjs, { Dayjs } from 'dayjs';
import { isBottomFromTechnicianCoordinator } from 'components/helpers/IsBottomFromTechnicianCoordinator';

interface DateSelectorDialogProps {
  dateField: string;
  entityId: number;
  initialDate?: Dayjs | null;
  initialMonth?: Dayjs | null;
}

export const DateSelectorDialog = ({
  dateField,
  entityId,
  initialDate,
  initialMonth
}: DateSelectorDialogProps) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(
    initialDate ? dayjs(initialDate, 'DD/MM/YYYY') : null
  );

  const isDisabledEdit = !isBottomFromTechnicianCoordinator();

  const handleClickOpen = () => !isDisabledEdit && setOpen(true);
  const handleClose = () => {
    setSelectedDate(initialDate ? dayjs(initialDate) : null);
    setOpen(false);
  };

  const handleSubmit = () => {
    if (!selectedDate) return;
    const formattedDate = selectedDate.format('YYYY-MM-DD');
    const payload = {
      [dateField]: formattedDate
    };

    maintenanceService.update(entityId, payload).then(() => {
      toast.success(t('toasts.updated-cell'));
      setOpen(false);
    });
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ButtonGroup variant="outlined" size="small">
          {!isDisabledEdit ? (
            <ButtonGroup variant="outlined" size="small">
              <Button onClick={handleClickOpen}>
                {selectedDate ? selectedDate.format('DD/MM/YYYY') : t('actions.insert')}
              </Button>
            </ButtonGroup>
          ) : selectedDate ? (
            <span>{selectedDate.format('DD/MM/YYYY')}</span>
          ) : null}
        </ButtonGroup>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>{t('actions.select-date')}</DialogTitle>
          <DialogContent>
            {initialMonth && (
              <DatePicker
                disabled={isDisabledEdit}
                value={selectedDate}
                onChange={(newValue) => setSelectedDate(newValue as Dayjs | null)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            )}
            {!initialMonth && (
              <DatePicker
                disabled={isDisabledEdit}
                value={selectedDate}
                onChange={(newValue) => setSelectedDate(newValue as Dayjs | null)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>{t('actions.cancel')}</Button>
            <Button onClick={handleSubmit} disabled={!selectedDate}>
              {t('actions.confirm')}
            </Button>
          </DialogActions>
        </Dialog>
      </LocalizationProvider>
    </>
  );
};
